{
  "back": "返回",
  "form": "表單",
  "purposeTitle": "您此次停靠的目的是什麼？",
  "appointmentInfoTitle": "預約資訊",
  "appointmentInfoHint": "如果您已有預約，請務必填寫此欄位。",
  "checkInDetailsTitle": "報到詳細資料",
  "checkInDetailsHint": "關於您此次到訪的其他資訊。",
  "driverPhoneLabel": "司機電話號碼",
  "activateWhatsAppTitle": "啟用 WhatsApp 訊息",
  "activateWhatsAppBody": "如需與倉庫聯繫，請在收到我們傳送的第一則 WhatsApp 訊息後回覆「OK」。",
  "whatsappDelayBanner": "第一則 WhatsApp 訊息最多可能需要一分鐘才會送達。",
  "notesLabel": "備註",
  "notesPlaceholder": "是否有需要告知倉庫的特殊指示或備註？",
  "verifyAndCheckIn": "驗證並報到",
  "completeCheckIn": "完成報到",
  "visitGroupInbound": "進貨",
  "visitGroupOutbound": "出貨",
  "visitGroupBoth": "進貨與出貨",
  "visitUnloadTruck": "為我的貨車卸貨",
  "visitDropTrailer": "放置我的拖車或貨櫃",
  "visitLoadTruck": "為我的貨車裝貨",
  "visitHookTrailer": "掛接拖車或貨櫃",
  "visitUnloadLoad": "為我的貨車卸貨並裝貨",
  "visitDropHook": "放置並掛接拖車或貨櫃",
  "containerTrailer": "拖車",
  "containerContainer": "貨櫃",
  "containerOversized": "超大型",
  "containerOther": "其他",
  "defaultReferenceName": "採購單號（PO Number）",
  "identifierSuffix": "{reference} 或確認號碼",
  "licenseOrDotRequired": "請填寫車牌號碼或 DOT 編號",
  "appointmentNotFound": "我們找不到您的預約",
  "referenceNotFound": "找不到相符的預約。參考編號區分大小寫。",
  "referenceCaseSensitiveHint": "參考編號區分大小寫",
  "messaging": {
    "whatsappFailedTitle": "無法傳送 WhatsApp 訊息",
    "smsFailedTitle": "無法傳送簡訊",
    "whatsappFailedBody": "我們無法傳送訊息至 {displayPhone}。<br /><br /> 如果您先前已取消訂閱，請傳送 START 至 <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a>，以重新開始接收此倉庫的訊息。",
    "smsFailedBody": "我們無法傳送訊息至 {displayPhone}。<br /><br /> 如果您先前已取消訂閱，請傳送簡訊 START 至 <a href='{smsUrl}'>{senderPhone}</a>，以重新開始接收此倉庫的簡訊。",
    "fallbackPhone": "所提供的電話號碼"
  }
}
